import House from "./SVG/house.svg?react";

const HouseIcon = () => {
  return <House />;
};

export default HouseIcon;
